<template>
  <button
    type="button"
    class="w-max flex gap-1 py-4 px-16 justify-center items-center rounded-md text-white text-base font-medium bg-main-color disabled:opacity-80 active:bg-main-color hover:bg-accent-color ease-linear transition-all duration-150 max-md:w-full"
    :disabled="loading"
    @click="onClick"
  >
    <InlineLoader :show-loader="loading"></InlineLoader>
    <slot></slot>
  </button>
</template>

<script setup>
import InlineLoader from '@cmp/InlineLoader.vue';

defineProps({
  loading: { type: Boolean, default: false },
});

// ✅ эмитим и стандарт, и старое событие
const emit = defineEmits(['click', 'onclick']);

const onClick = e => {
  emit('click', e);
  emit('onclick', e);
};
</script>
